import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import { ProgressProvider } from "./context/ProgressContext";
import { ModalityProvider } from "./context/ModalityContext";
import { Layout } from "./components/Layout";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import MedicationGame from "./pages/MedicationGame";
import EkgTrainer from "./pages/EkgTrainer";
import Profile from "./pages/Profile";
import DailyChallenge from "./pages/DailyChallenge";
import Flashcards from "./pages/Flashcards";
import Teams from "./pages/Teams";
import Avatars from "./pages/Avatars";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProgressProvider>
          <ModalityProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/medication-game" element={<MedicationGame />} />
              <Route path="/ekg-trainer" element={<EkgTrainer />} />
              <Route path="/daily" element={<DailyChallenge />} />
              <Route path="/flashcards" element={<Flashcards />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/avatars" element={<Avatars />} />
              <Route path="/profile" element={<Profile />} />
            </Routes>
          </Layout>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "hsl(240 10% 6%)",
                border: "1px solid hsl(142 71% 45% / 0.4)",
                color: "hsl(210 40% 98%)",
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "12px",
                borderRadius: 2,
              },
            }}
          />
          </ModalityProvider>
        </ProgressProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
